<template>
  <div class="app">
    <div v-if="isLoading" id="landing_loader" class="landing-loader">
      <div class="logo" />
    </div>
    <template v-else>
      <TheHeader />
      <main class="app__main">
        <RouterView />
      </main>
      <TheFooter />
    </template>
  </div>
</template>

<script lang="ts" src="./LandingLayout.ts">

</script>

<style scoped lang="scss" src="./LandingLayout.scss"></style>
